import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import SelectGroups from 'react-select';
import SelectDivision from 'react-select';
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const CreateUserComp = (props) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [disabledDivision, setDisabledDivision] = useState(false);
  const [fullname, setfullname] = useState('');
  const [username, setusername] = useState('');
  const [nik, setnik] = useState('');
  const [email, setemail] = useState('');
  const [password, setpassword] = useState('');
  const [idGroup, setidGroup] = useState('');
  const [groups, setgroups] = useState([]);
  const [idDivision, setidDivision] = useState('');
  const [divisions, setdivisions] = useState([]);
  const [jabatan, setjabatan] = useState('');

  const fetchGroups = async () => {
    try {
      const options = {
        url: `/groups/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setgroups([]);
      data.map((d) =>
        setgroups((group) => [
          ...group,
          {
            label: d.namaGroup,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDivisions = async () => {
    try {
      const options = {
        url: `/risk-divisions/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setdivisions([]);
      data.map((d) =>
        setdivisions((divisions) => [
          ...divisions,
          {
            label: d.namaDivision,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchGroups();
    fetchDivisions();
  }, []);

  const handleCreate = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      username: username,
      nik: parseInt(nik) || null,
      email: email,
      namaLengkap: fullname,
      password: password,
      idGroups: idGroup?.value,
      idDivision: idDivision?.value,
      jabatan: jabatan,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: '/users/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully created User!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  const handleChangeGroup = (object) => {
    // if surveyor external
    setidGroup(object)
    if (object?.value === "34373ecb-00d0-4e0b-b1f7-f1095993dc49") {
      setDisabledDivision(true)
      setidDivision({
        label: "Pihak External",
        value: "ad80872a-d0fc-47fa-9df8-ab4d5d55826f"
      })
      setjabatan("Surveior External")
    } else {
      setDisabledDivision(false)
      setidDivision("")
      setjabatan("")
    }
  }

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="fullname" className="col-sm-2 col-form-label required">
          Nama
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="fullname"
            onChange={(e) => setfullname(e.target.value)}
            value={fullname}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="nik" className="col-sm-2 col-form-label required">
          NIK
        </label>
        <div className="col-sm-10">
          <input
            type="number"
            className="form-control"
            id="nik"
            onChange={(e) => setnik(e.target.value)}
            value={nik}
          />
          <small className='text-info'>Tidak wajib di isi untuk Group Surveior External</small>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="email" className="col-sm-2 col-form-label required">
          Email
        </label>
        <div className="col-sm-10">
          <input
            type="email"
            className="form-control"
            id="email"
            onChange={(e) => setemail(e.target.value)}
            value={email}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="username" className="col-sm-2 col-form-label required">
          Username
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="username"
            onChange={(e) => setusername(e.target.value)}
            value={username}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="password" className="col-sm-2 col-form-label required">
          Password
        </label>
        <div className="col-sm-10">
          <input
            type="password"
            className="form-control"
            id="password"
            onChange={(e) => setpassword(e.target.value)}
            value={password}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="group" className="col-sm-2 col-form-label required">
          Group
        </label>
        <div className="col-sm-10">
          <SelectGroups
            id="group"
            value={idGroup}
            onChange={handleChangeGroup}
            options={groups}
            placeholder="Cari groups"
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label
          htmlFor="namaDivision"
          className="col-sm-2 col-form-label required"
        >
          Division
        </label>
        <div className="col-sm-10">
          <SelectDivision
            id="namaDivisions"
            value={idDivision}
            onChange={setidDivision}
            options={divisions}
            placeholder="Cari division"
            isDisabled={disabledDivision}
          />
          <small className='text-info'></small>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="jabatan" className="col-sm-2 col-form-label required">
          Jabatan
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="jabatan"
            onChange={(e) => setjabatan(e.target.value)}
            value={jabatan}
            disabled={disabledDivision}
          />
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleCreate()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateUserComp;
